<template>
  <div class="wrapper">
    <page-header title="Rozliczenia" />
    <h2>Harmonogram wpłat</h2>
    <course-payment-list read-only :student-id="userInfo.id" class="mb-24" />
    <agreements-list :user-id="userInfo.id" />
  </div>
</template>

<script>
import CoursePaymentList from '@/views/AdminPanel/Student/Details/Payments/CoursePayment/'
import AgreementsList from '@/components/AgreementsList/'

export default {
  components: {
    CoursePaymentList,
    AgreementsList
  }
}
</script>
